import {HelperMessage} from "@atlaskit/form";
import type {ComponentProps} from "react";

export function AnankeHelperMessage(props: ComponentProps<typeof HelperMessage>) {
    return <HelperMessage {...props} />;
}
